import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpInitChat implements ICommand
{

	public Trial : number = 0;
	public internalTestMode : number = 0;
	public ChatEnable : number = 0;
	public HideMessage : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Trial = ba.readUint16();
		this.internalTestMode = ba.readUint16();
		this.ChatEnable = ba.readUint16();
		this.HideMessage = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.Trial);
		ba.writeUint16(this.internalTestMode);
		ba.writeUint16(this.ChatEnable);
		ba.writeUint16(this.HideMessage);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpInitChat();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Trial(W)='+this.Trial+' ';
		str += 'internalTestMode(W)='+this.internalTestMode+' ';
		str += 'ChatEnable(W)='+this.ChatEnable+' ';
		str += 'HideMessage(W)='+this.HideMessage+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50146;
	}

	public getCmdName() : string
	{
		return 'SpInitChat';
	}

}
